// @flow

import React from 'react';
import hexToRgba from 'hex-to-rgba';
import styled from 'styled-components';

import {
  GREY_01_COLOR, PRIMARY_COLOR, TRANSITION_DEFAULT_LEN, WHITE_COLOR,
} from '../config/constants';

const ProgressWrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${(props) => `${props.height}px` || '2px'};
  background-color: ${(props) => props.color || GREY_01_COLOR};
`;

const ProgressIndicator = styled.div`
  position: absolute;
  width: ${(props) => `${props.percentage}%` || 0};
  height: 100%;
  background-color: ${(props) => props.color || WHITE_COLOR};
  transition: width ${TRANSITION_DEFAULT_LEN}s;
`;

// eslint-disable-next-line react/prefer-stateless-function
class SYProgressBar extends React.Component<{|
  backgroundColor?: string,
  fillColor?: string,
  height?: number,
  percentage: number,
  style?: Object,
|}> {
  static defaultProps = {
    backgroundColor: hexToRgba(WHITE_COLOR, 0.2),
    fillColor: PRIMARY_COLOR,
    height: 2,
    style: {},
  };

  render() {
    const {
      percentage, height, fillColor, backgroundColor, style, ...rest
    } = this.props;

    return (
      <ProgressWrapper style={style} height={height} color={backgroundColor} {...rest}>
        <ProgressIndicator percentage={percentage} color={fillColor} />
      </ProgressWrapper>
    );
  }
}

export default SYProgressBar;
